import { render } from "./Descripcion.vue?vue&type=template&id=40d7fae4"
import script from "./Descripcion.vue?vue&type=script&lang=js"
export * from "./Descripcion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__